var _style, _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagingTemplateBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 496 620",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#e0e0e0;}\r\n\t.st1{fill:#e0e0e0;}\r\n\t.st2{fill:#e0e0e0;}\r\n\t.st3{fill:none;}\r\n\t.st4{fill:#e0e0e0;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 48,
    className: "st1",
    width: 432,
    height: 80
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0 0v620h496V0H0zM16 604V32h464v572H16z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 160,
    className: "st2",
    width: 208,
    height: 120
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 160,
    className: "st2",
    width: 208,
    height: 120
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 308,
    className: "st1",
    width: 208,
    height: 8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 328,
    className: "st1",
    width: 208,
    height: 8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 308,
    className: "st1",
    width: 208,
    height: 8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 328,
    className: "st1",
    width: 208,
    height: 8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 348,
    className: "st1",
    width: 208,
    height: 8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 368,
    className: "st1",
    width: 208,
    height: 8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 348,
    className: "st1",
    width: 208,
    height: 8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 368,
    className: "st1",
    width: 208,
    height: 8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 388,
    className: "st1",
    width: 208,
    height: 8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 408,
    className: "st1",
    width: 208,
    height: 8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 388,
    className: "st1",
    width: 208,
    height: 8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 408,
    className: "st1",
    width: 208,
    height: 8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 428,
    className: "st1",
    width: 208,
    height: 8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 448,
    className: "st1",
    width: 208,
    height: 8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 428,
    className: "st1",
    width: 208,
    height: 8
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 448,
    className: "st1",
    width: 208,
    height: 8
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 468,
    className: "st1",
    width: 208,
    height: 8
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 488,
    className: "st1",
    width: 208,
    height: 8
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 468,
    className: "st1",
    width: 208,
    height: 8
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 488,
    className: "st1",
    width: 208,
    height: 8
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 508,
    className: "st1",
    width: 208,
    height: 8
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 528,
    className: "st1",
    width: 208,
    height: 8
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 508,
    className: "st1",
    width: 208,
    height: 8
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 528,
    className: "st1",
    width: 208,
    height: 8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagingTemplateBg);
export default __webpack_public_path__ + "static/media/messagingTemplateBg.7c6f25e12b5d21c07e7d4d53456a0ee1.svg";
export { ForwardRef as ReactComponent };